import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  root: {
    marginTop: 24,
    [breakpoints.down('sm')]: {
      width: '100%',
    },
    '& .ov-step-number': {
      alignSelf: 'center',
      display: 'flex',
      justifyContent: 'flex-end',
      '& .MuiAvatar-root': {
        marginRight: 16,
        fontSize: 18,
        backgroundColor: palette.cncUI.default['-3'],
        color: palette.cncUI.default['+10'],
        width: 30,
        height: 30,
      },
    },
    '& .ov-step-message': {
      '& p': {
        textAlign: 'left',
        color: '#5c5c5c',
        fontSize: 14,
        fontWeight: 400,
        maxWidth: 347,
        width: 347,
        [breakpoints.down('sm')]: {
          maxWidth: 230,
        },
      },
    },
  },
}));

const Step = props => {
  const classes = useStyles();
  const { number, children, isMobile } = props;
  return (
    <Grid container className={classes.root}>
      {isMobile && <Grid item xs={1} />}
      <Grid item xs={2} lg={2} className="ov-step-number">
        <Avatar>{number}</Avatar>
      </Grid>
      <Grid item xs={8} lg={10} className="ov-step-message">
        <p>{children}</p>
      </Grid>
      {isMobile && <Grid item xs={1} />}
    </Grid>
  );
};

export default Step;
